import { Grid, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  saveOurEntityTaxation,
  ITaxTypesDetails,
  OurEntityTaxation,
  getAllVisibleTaxType,
  saveActivityLog,
  LogAction,
  LogEntityType,
  LogContextType,
} from 'wisestep-api';
import { WsButton, WsLocationSearch } from 'wisestep-base';

import { DrawerFooter } from '../../../components/filters/components/AdvanceFilterFooterBar';
import { activityLogDTOHelper } from '../../../features/activityLog/ActivityHelper';
import { failed, success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { AutocompleteWithPersistentAdd } from '../../clientDetails/components/contractArrangementsTab/AddEditFeeArrangement';
import { FormProps } from '../../clientsSettings/components/FormProps';

interface OurEntityTaxationFormProps extends FormProps<OurEntityTaxation> {
  ourEntityId: string;
}

export const withLabelTaxType = (t) => ({ ...t, label: `${t.name}-${t.rate}%` });

export const OurEntityTaxationForm = ({
  defaultValues,
  onClose,
  onSave,
  ourEntityId,
}: OurEntityTaxationFormProps) => {
  const form = useForm<OurEntityTaxation>({ defaultValues });
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [taxTypeList, setTaxTypeList] = useState<ITaxTypesDetails[]>([]);

  useEffect(() => {
    getAllVisibleTaxType().then((response) => setTaxTypeList(response.data.map(withLabelTaxType)));
  }, []);
  return (
    <FormProvider {...form}>
      <form
        onSubmit={form.handleSubmit(async (data) => {
          const avPayload = { ...activityLogDTOHelper };
          const modifiedValue: string[] = [];
          try {
            const res = await saveOurEntityTaxation({ ...data, ourEntityId });
            if (data.id) {
              defaultValues?.location?.country != data.location?.country
                ? modifiedValue.push('country')
                : '';
              defaultValues?.taxType?.name != data.taxType?.name
                ? modifiedValue.push('TaxType')
                : '';
              avPayload.action = LogAction.Edit;
              avPayload.description = `EDITED ${modifiedValue.toString()} under`;
            } else {
              avPayload.action = LogAction.Add;
              avPayload.description = `ADDED ${data.taxType.name} under`;
            }
            avPayload.parentEntitiyType = LogContextType.OurEntity;
            avPayload.entityType = LogEntityType.Taxation;
            avPayload.entityId = res.data.id;
            avPayload.parentEntitiyId = ourEntityId;
            avPayload.field = `Taxation`;
            avPayload.entityName = data.taxType.name;
            avPayload.contextData = { ourEntityId: ourEntityId };
            if (data.id) {
              modifiedValue.length > 0 ? await saveActivityLog(avPayload) : '';
            } else {
              await saveActivityLog(avPayload);
            }
            setNotification(success('Taxation saved successfully!'));
            onSave();
          } catch (e) {
            setNotification(failed('Some error occurred. Please try later'));
          }
        })}
      >
        <Grid p={2} spacing={2} container>
          <Grid item xs={6}>
            <WsLocationSearch
              multiSelect={false}
              hideLabel
              types={['administrative_area_level_1', 'country']}
              name="location"
              placeHolder="Enter State, Country"
              required={true}
            />
          </Grid>
          <Grid item xs={6}>
            <AutocompleteWithPersistentAdd
              name="taxType"
              options={taxTypeList}
              placeholder="Select Taxation"
              required={true}
            />
          </Grid>
        </Grid>
        <DrawerFooter>
          <Stack p={1} columnGap={2} direction="row" flexDirection="row-reverse">
            <WsButton size="large" type="submit">
              Add
            </WsButton>
            <WsButton onClick={() => onClose()} variant="outlined" size="large">
              Cancel
            </WsButton>
          </Stack>
        </DrawerFooter>
      </form>
    </FormProvider>
  );
};
